import { Link as MultibrandLink } from '@vgw/multibrand-fe-link'
import { Trans, useLingui } from '@lingui/react/macro'
import { getBrandConfig } from '@/config/config'

export const LicenseDetails = () => {
  const { t } = useLingui()
  const { name } = getBrandConfig()

  return (
    <p
      className="max-w-(--breakpoint-xl) text-content-variant lg:text-center xl:m-auto"
      title="License Details"
    >
      <Trans>
        © {new Date().getFullYear()} VGW Group. All rights reserved. {name} is
        owned and operated by Beefour Limited. All payments are processed by
        BeefourLimited or any payment administration agent it appoints. The
        sweepstakes promotions and prizes offered by {name} are operated by VGW
        Games Limited. The registered address of VGW Games Limited is Trident
        Park, Notabile Gardens, No6 - Level 3 Central Business District Mdina
        Road, Zone 2 BIRKIRKARA, CBD2010, Malta. VGW Games Limited is licensed
        and regulated in Malta by the Malta Gaming Authority (MGA) to operate
        the promotional play games with the licence{' '}
        <MultibrandLink
          size="xs"
          target="_blank"
          rel="noopener"
          href="https://authorisation.mga.org.mt/verification.aspx?lang=EN&company=4debab56-21d5-49fd-96c5-1c2b5500dbb4&details=1"
          aria-label={t`Read Malta Gaming Authority document to learn more`}
          title={t`Read Malta Gaming Authority document to learn more`}
        >
          MGA/B2C/188/2010
        </MultibrandLink>{' '}
        issued on 1st August 2018.
      </Trans>
    </p>
  )
}
